import { ContainerV1Properties } from '@adobe/aem-core-components-react-spa'

export enum VerticalAlignment {
  top = 'start',
  middle = 'center',
  bottom = 'end'
}

export enum HorizontalAlignment {
  left = 'start',
  center = 'center',
  right = 'end',
  default = 'default'
}

export enum LayoutBackgroundTypes {
  transparent = 'transparent',
  image = 'image',
  color = 'color'
}

export interface ReactLayoutProps extends ContainerV1Properties {
  verticalAlignment: keyof typeof VerticalAlignment | string
  horizontalAlignment: keyof typeof HorizontalAlignment | string
  layoutBackground: string
  backgroundImage?: string
  backgroundColor?: string
  reverseStacking?: boolean
  // Hides only second column in mobile
  hideInMobile?: boolean
  sideSpace?: boolean
  borderRadius?: boolean
  top?: boolean
  right?: boolean
  bottom?: boolean
  left?: boolean
  lob?: string
}
